import { ProductMeta } from '../entities/product-meta.entity.ts';
import { MetaCodeVariant, ProductMetaCode } from '@services/MarppleShop/features/ProductMeta';

export class ProductId {
  private readonly _value: number;

  constructor(value: number) {
    if (value <= 0) {
      throw new Error('ProductId must be positive');
    }
    this._value = value;
  }

  get value(): number {
    return this._value;
  }

  equals(other: ProductId): boolean {
    return this._value === other.value;
  }
}

export interface IProductMetaQueryRepository {
  findByProductId(productId: ProductId): Promise<ProductMeta | undefined>;

  findByProductIds(productIds: ProductId[]): Promise<Map<number, ProductMeta>>;

  findMetaCodeVariants(
    items: {
      meta_code: ProductMetaCode;
      variant: string;

      // TODO: 나중에 marketplace name 으로 받아야 함
      marketplace_id: number;
    }[],
  ): Promise<MetaCodeVariant[]>;

  exists(productId: ProductId): Promise<boolean>;
}

export interface IProductMetaCommandRepository {
  save(product_meta: ProductMeta): Promise<void>;

  delete(productId: ProductId): Promise<void>;

  deleteAll(productIds: ProductId[]): Promise<void>;
}
